import { default as documentApi } from './serviceApi';
import { default as hubspotApi } from './serviceIoApi';


const uploadEmailTemplate = async(payload, options={}) => {
    return await documentApi.post(`/emails/templates`, payload, options, {
    }).then(response => {
        return response
    })
};

const sendEmail = async(payload, options={timeout: 180000}) => {
    return await documentApi.post(`/emails`, payload, options, {
    }).then(response =>{
        return response
    })
}

const refreshLimitToken = async (refresh) => {
    let url = '/auth/refresh/guest'
    const body = {
      "refresh_token": refresh
    }
    return await documentApi.post(url,body)
    .then((response) => {
      return response.data
    })
    .catch((error)=> {
      console.error("An error occurred:", error);
      return error
    })
  }

const sendToHubspot = async (payload, role, options={}) => {

  const hubspotPayload = {
    "properties" : {
      "email": payload.email,
      "name": payload.fullName,
      "firstname": payload.firstName,
      "lastname": payload.lastName,
      "company": payload.company,
      "jobtitle": payload.position,
      "job_description_template_to_be_downloaded": role,
      "created_by_jd_builder": "Yes",
    }
  }

  return await hubspotApi.post(`/hubspot/contacts`, hubspotPayload, options, {
  }).then(response => {
      return response
  })
}


export const useCommonService = () => {
    const options = {}
    const services = {
        uploadEmailTemplate,
        sendEmail,
        refreshLimitToken,
        sendToHubspot
    }

    return [
       { ...services}
    ]
  }

  export const useCommon = () => {
    const [  handlers ] = useCommonService()
    return [ handlers ]
  }